interface ICta {
  type: string
  text: string
  url: string
}

export interface IBannerItem {
  name: string
  content: string
  image?: string
  cta?: ICta
  enabled: boolean
}

export class BannerItem {
  name: string
  content: string
  image?: string
  cta?: ICta
  enabled: boolean
  constructor(from: IBannerItem) {
    this.name = from.name
    this.content = from.content
    this.image = from.image
    this.cta = from.cta
    this.enabled = from.enabled
  }
}
